export default __webpack_public_path__ + "static/media/img_gestao_certificados.fad9f5f2.jpg";